/**
 * Jelszót validál: minimum 8 karakter,legalább 3 a következőkből: kisbetű, nagybetű, szám, speci karakter
 * nem tartalmazhat ékezetes betűt
 * @author Bálint Ádám
 */
export default function(app) {
	app.directive('passwordValidate', function () {
		return {
			scope: {
				passwordValue: '=',
				usernameValue: '='
			},
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {

				scope.$watch('passwordValue', function (newValue) {
					var counter = 0;
					var noInvalidChar = true;
					if (newValue) {
						counter += /[a-z]/.test(newValue) + /[A-Z]/.test(newValue) + /[0-9]/.test(newValue) + /[^a-zA-Z0-9áéíóöőúüűÁÉÍÓÖŐÚÜŰ]/.test(newValue);
						noInvalidChar = (/^[A-z0-9\u0020-\u007e]+$/g).test(newValue);
						ctrl.$setValidity('passwordHasLowercaseChar', /[a-z]/.test(newValue));
						ctrl.$setValidity('passwordHasUppercaseChar', /[A-Z]/.test(newValue));
						ctrl.$setValidity('passwordHasNumber', /[0-9]/.test(newValue));
						ctrl.$setValidity('minlength', newValue.length >= 8);
						if (scope.usernameValue) {
							if (!String.prototype.includes) {
								String.prototype.includes = function () {
									'use strict';
									return String.prototype.indexOf.apply(this, arguments) !== -1;
								};
							}
							ctrl.$setValidity('passwordContainsUsername', !newValue.toLowerCase().includes(scope.usernameValue.toLowerCase()));
						}
					}
					ctrl.$setValidity('passwordFormatWeakPass', counter >= 3);
					ctrl.$setValidity('passwordFormatInvalidChar', noInvalidChar);
				});

			}
		};
	});
};
